/**
 * CRO-WEB-176 Experiment Configuration
 *
 * Configuration for the personalisation subheader experiment on preference selection steps.
 * Tests different subheader text to improve user engagement and completion rates.
 */

import type { ExperimentConfig } from "@/src/experiments/useExperimentTracking";
import { getCroWeb176Variant } from "./getCroWeb176Variant";

export const croWeb176Config: ExperimentConfig = {
  name: "cro-web-176",
  getVariant: getCroWeb176Variant,
  eventName: "cro_web_176_experiment_participation",
  featureFlagName: "cro-web-176",
  variants: ["control", "test"],
};
